import { useEffect, useRef } from 'react';
import { Platform, TouchableOpacity, ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';
import { useVideoPlayer, VideoView } from 'expo-video';
import { useEvent } from 'expo';
import { Box } from '@/components/base/box';
import { AppIconButton } from '@/components/base/app.icon.button';
import { SafeAreaView } from '@/components/base/safe.area.view';
import { useAppRouter } from '@/hooks/use.app.router';
import { useNavigation } from '@react-navigation/native';
import { AppModal } from '@/components/compose/app.modal';
import { playbackStarted } from '../../utils/playback.manager';

export default function VideoPlayerModal() {
  const navigation = useNavigation();
  const { params } = useAppRouter();
  const uri = (params as any).uri;
  const videoViewRef = useRef<VideoView>(null);

  /*  useBackButton(() => {
    navigation.goBack();
    return true;
  }, [navigation]);*/

  const player = useVideoPlayer(uri, (p) => {
    p.loop = false;
  });

  useEffect(() => {
    playbackStarted(player);
  }, [player]);

  const { status } = useEvent(player, 'statusChange', { status: player.status });

  useEffect(() => {
    if (uri) {
      player.play();
    }
  }, [player, uri]);

  return (
    <AppModal>
      <SafeAreaView>
        <BackdropContainer disabled activeOpacity={1} onPress={() => navigation.goBack()}>
          <VideoBounds>
            <VideoContainer>
              <StyledVideoView
                ref={videoViewRef}
                player={player}
                fullscreenOptions={{ enable: true }}
                allowsPictureInPicture={false}
                nativeControls={true}
                contentFit="contain"
              />

              <HeaderContainer pointerEvents="box-none">
                <CloseButton onPress={() => navigation.goBack()} activeOpacity={0.7}>
                  <AppIconButton icon={'back'} size={'medium'} color={'#ffffff'} />
                </CloseButton>
              </HeaderContainer>

              {status === 'loading' && (
                <LoadingOverlay pointerEvents="none">
                  <ActivityIndicator size="large" color="#ffffff" />
                </LoadingOverlay>
              )}
            </VideoContainer>
          </VideoBounds>
        </BackdropContainer>
      </SafeAreaView>
    </AppModal>
  );
}

const BackdropContainer = styled(TouchableOpacity)`
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.98);
  justify-content: center;
  align-items: center;
`;

const VideoBounds = styled(Box)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
`;

const VideoContainer = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
`;

const StyledVideoView = styled(VideoView)`
  width: 100%;
  height: 100%;
  flex: 1;
`;

const HeaderContainer = styled(Box)`
  position: absolute;
  top: 35px;
  left: 13px;
  z-index: 1000;
`;

const CloseButton = styled(TouchableOpacity)`
  width: 44px;
  height: 44px;
  border-radius: 22px;
  justify-content: center;
  align-items: center;
`;

const LoadingOverlay = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 5;
`;
